import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "max-w-[420px] rounded-lg border border-gray-300 p-3" }
const _hoisted_2 = { class: "grid grid-cols-7 gap-1" }
const _hoisted_3 = ["data-date", "aria-pressed", "title", "aria-label", "onClick"]

import { computed } from 'vue'


export default {
  __name: 'DateGrid',
  props: {
  modelValue: { type: String, default: null },
  days: { type: Number, default: 21 },
  startOffset: { type: Number, default: 1 },
  tz: { type: String, default: undefined }
},
  emits: ['update:modelValue'],
  setup(__props) {

const HEADS = ['S', 'M', 'T', 'W', 'T', 'F', 'S']

const props = __props


const todayParts = () => {
  const formatted = new Intl.DateTimeFormat('en-CA', {
    timeZone: props.tz,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(new Date())
  const [year, month, day] = formatted.split('-').map(Number)
  return new Date(year, month - 1, day)
}

const iso = date =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
const MONTHS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']

const cells = computed(() => {
  const start = todayParts()
  start.setDate(start.getDate() + props.startOffset)
  return Array.from({ length: props.days }, (_, i) => {
    const date = new Date(start)
    date.setDate(start.getDate() + i)
    return {
      iso: iso(date),
      number: date.getDate(),
      month: i === 0 || date.getDate() === 1 ? MONTHS[date.getMonth()] : '',
      column: date.getDay() + 1,
      title: date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })
    }
  })
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(HEADS, (head, i) => {
        return _createElementVNode("div", {
          key: i,
          class: "py-0.5 text-center text-xs text-gray-500"
        }, _toDisplayString(head), 1)
      }), 64)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cells.value, (day, i) => {
        return (_openBlock(), _createElementBlock("button", {
          key: day.iso,
          type: "button",
          "data-date": day.iso,
          "aria-pressed": day.iso === __props.modelValue,
          title: day.title,
          "aria-label": day.title,
          class: _normalizeClass(["flex h-11 flex-col items-center justify-center rounded-lg border text-[15px] font-semibold leading-tight", 
          day.iso === __props.modelValue
            ? 'border-gray-900 bg-gray-900 text-white'
            : 'border-gray-200 bg-white text-gray-800 hover:border-gray-400'
        ]),
          style: _normalizeStyle(i === 0 ? { gridColumn: String(day.column) } : undefined),
          onClick: $event => (_ctx.$emit('update:modelValue', day.iso))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["text-[10px] font-semibold tracking-wide", day.iso === __props.modelValue ? 'text-gray-300' : 'text-gray-400'])
          }, _toDisplayString(day.month), 3),
          _createElementVNode("span", null, _toDisplayString(day.number), 1)
        ], 14, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

}